<div class="container py-5">
    <h2>Principales Características</h2>
    <ul>
        <li>Alerta comunitaria inmediata ante amenazas.</li>
        <li>Notificaciones personalizadas por zonas de interés.</li>
        <li>Historial de incidentes para prevenir riesgos.</li>
        <li>Integración con tu red de vecinos y familiares.</li>
    </ul>
</div>